import { ApiService } from '../../../services/api.service';
import { CUSTOMER_TYPES } from '../../../services/constant';
import { Router } from '@angular/router';
import { CustomerDetailComponent } from '../customer-detail/customer-detail.component';
import { HttpParams } from '@angular/common/http';
var CustomerListComponent = (function () {
    function CustomerListComponent(apiService, router) {
        this.apiService = apiService;
        this.router = router;
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.searchingName = false;
        this.searchingTaxID = false;
        this.searchingBranchCode = false;
        this.searchingBranchName = false;
        this.loading = false;
        this.sentdata = null;
        this.list = [];
        this.customerTypes = CUSTOMER_TYPES;
        this.selectedCustomerType = this.customerTypes[0];
    }
    CustomerListComponent.prototype.ngOnInit = function () {
        this.initData();
        this.loadData();
    };
    Object.defineProperty(CustomerListComponent.prototype, "isForeignCorporation", {
        get: function () {
            return this.selectedCustomerType.type === 'foreign_corporation';
        },
        enumerable: true,
        configurable: true
    });
    CustomerListComponent.prototype.selectCustomerType = function (type) {
        this.selectedCustomerType = type;
        this.loadData();
    };
    CustomerListComponent.prototype.initData = function () {
        var _this = this;
        this.apiService.getNewBuyer().subscribe(function (res) {
            _this.buyerNameList = res.map(function (obj) { return obj.name; }).filter(function (item) { return item; }).filter(function (item, index, array) {
                return array.indexOf(item) === index;
            });
            _this.buyerTaxIDList = res.map(function (obj) { return obj.tax_id; }).filter(function (item) { return item; }).filter(function (item, index, array) {
                return array.indexOf(item) === index;
            });
        });
        this.apiService.getBuyerBranch().subscribe(function (res) {
            _this.buyerBranchCodeList = res.results.map(function (obj) { return obj.branch_code; }).filter(function (item) { return item; }).filter(function (item, index, array) {
                return array.indexOf(item) === index;
            });
        });
    };
    CustomerListComponent.prototype.loadData = function (page) {
        var _this = this;
        var sniffTargetArr = [];
        var params = new HttpParams();
        if (this.searchName) {
            params = params.append('name', this.searchName);
            sniffTargetArr.push('NORMAL.CUS-NAME');
        }
        if (this.searchTaxID) {
            params = params.append('tax_id', this.searchTaxID);
            sniffTargetArr.push('TABLE.TAX-ID');
        }
        if (this.searchBranchCode) {
            params = params.append('branch_code', this.searchBranchCode);
            sniffTargetArr.push('NORMAL.BRANCH-NAME-CODE');
        }
        if (this.searchBranchName) {
            params = params.append('branch_name', this.searchBranchName);
        }
        if (this.sentdata) {
            params = params.append('page', this.currentPage.toString());
            params = params.append('page_size', this.itemsPerPage.toString());
        }
        this.loading = true;
        this.apiService.getBuyerBranch(params).subscribe(function (res) {
            _this.list = res.results;
            _this.loading = false;
            if (res) {
                _this.totalItems = res.count;
            }
        }, function (error) {
            _this.loading = false;
        });
        if (page == null) {
            var sniffTarget = sniffTargetArr.join(', ');
            this.sniff('SEARCH', sniffTarget);
        }
    };
    CustomerListComponent.prototype.pageChanged = function () {
        this.sentdata = 1;
        this.loadData(this.currentPage);
    };
    CustomerListComponent.prototype.optionChanged = function () {
        this.search();
    };
    CustomerListComponent.prototype.search = function () {
        this.currentPage = 1;
        this.loadData();
    };
    CustomerListComponent.prototype.clearSearch = function () {
        this.searchName = null;
        this.searchTaxID = null;
        this.searchBranchCode = null;
        this.searchBranchName = null;
        this.search();
    };
    CustomerListComponent.prototype.openModal = function (index) {
        this.detailModal.open(this, this.selectedCustomerType, this.list[index]);
    };
    CustomerListComponent.prototype.issue = function (index) {
        var id = this.list[index].id;
        this.router.navigate(['document', 'issue', { buyer_branch: id }]);
    };
    CustomerListComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'CUS_INFO',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    return CustomerListComponent;
}());
export { CustomerListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-list/customer-list.component.ts.pre-build-optimizer.js